export default `
# H1 header
## H2 header
### H3 header
#### H4 header
##### H5 header
###### H6 header

# [H1](https://opensea.io/ "H1 link")
## [H2 link](https://opensea.io/ "H2 link")
### [H3 link](https://opensea.io/ "H3 link")
#### [H4 link](https://opensea.io/ "H4 link")
##### [H5 link](https://opensea.io/ "H5 link")
###### [H6 link](https://opensea.io/ "H6 link")

### Characters

----

~~Strikethrough~~ <s>Strikethrough (when enable html tag decode.)</s>
*Italic*      _Italic_
**Emphasis**  __Emphasis__
***Emphasis Italic*** ___Emphasis Italic___

Superscript: X<sub>2</sub>，Subscript: O<sup>2</sup>

###Blockquotes

> Blockquotes

Paragraphs and Line Breaks

> "Blockquotes Blockquotes", [Link](http://opensea.io/)

### Links

[Links](http://opensea.io/)

[Links with title](http://opensea.io/ "link title")

[Reference link][id/name]

[id/name]: http://opensea.io/

### Code Blocks (multi-language) & highlighting

#### Inline code

\`$ npm install marked\`

#### Code Blocks (Indented style)

Code Blocks (Preformatted text):

    | First Header  | Second Header |
    | ------------- | ------------- |
    | Content Cell  | Content Cell  |
    | Content Cell  | Content Cell  |

#### Javascript

\`\`\`javascript
function test(){
	console.log("Hello world!");
}

(function(){
    var box = function(){
        return box.fn.init();
    };

    box.prototype = box.fn = {
        init : function(){
            console.log('box.init()');

			return this;
        },

		add : function(str){
			alert("add", str);

			return this;
		},

		remove : function(str){
			alert("remove", str);

			return this;
		}
    };

    box.fn.init.prototype = box.fn;

    window.box =box;
})();

var testBox = box();
testBox.add("jQuery").remove("jQuery");
\`\`\`

#### HTML code (should be stripped)

\`\`\`html
<!DOCTYPE html>
<html>
    <head>
        <mate charest="utf-8" />
        <title>Hello world!</title>
    </head>
    <body>
        <h1>Hello world!</h1>
    </body>
</html>
\`\`\`

### Images (should be stripped)

Image:

![](https://lh3.googleusercontent.com/M6PCwMcbgt3uK6BHLJ0_gGmh_rLpvjX_KwyDc1CBBThK0G6-5QLHDFUOVjVFSgGYtE75wKbYh6UErcjavTFCL51KdMeIsPFUD3UQ=w600)

Image + Link：

[![](https://opensea.io/)](https://lh3.googleusercontent.com/M6PCwMcbgt3uK6BHLJ0_gGmh_rLpvjX_KwyDc1CBBThK0G6-5QLHDFUOVjVFSgGYtE75wKbYh6UErcjavTFCL51KdMeIsPFUD3UQ=w600 "this should be stripped and not visible")

----

### Lists

#### Unordered list (-)

- Item A
- Item B
- Item C


#### Unordered list (*)

* Item A
* Item B
* Item C


#### Unordered list (plus sign and nested)

+ Item A
+ Item B
    + Item B 1
    + Item B 2
    + Item B 3
+ Item C
    * Item C 1
    * Item C 2
    * Item C 3

#### Ordered list

1. Item A
2. Item B
3. Item C


----


### Tables

First Header  | Second Header
------------- | -------------
Content Cell  | Content Cell
Content Cell  | Content Cell

| First Header  | Second Header |
| ------------- | ------------- |
| Content Cell  | Content Cell  |
| Content Cell  | Content Cell  |

| Function name | Description                    |
| ------------- | ------------------------------ |
| \`help()\`      | Display the help window.       |
| \`destroy()\`   | **Destroy your computer!**     |

| Item      | Value |
| --------- | -----:|
| Computer  | $1600 |
| Phone     |   $12 |
| Pipe      |    $1 |

| Left-Aligned  | Center Aligned  | Right Aligned |
| :------------ |:---------------:| -----:|
| col 3 is      | some wordy text | $1600 |
| col 2 is      | centered        |   $12 |
| zebra stripes | are neat        |    $1 |

----

#### HTML entities

&copy; &  &uml; &trade; &iexcl; &pound;
&amp; &lt; &gt; &yen; &euro; &reg; &plusmn; &para; &sect; &brvbar; &macr; &laquo; &middot;

X&sup2; Y&sup3; &frac34; &frac14;  &times;  &divide;   &raquo;

18&ordm;C  &quot;  &apos;

## Escaping for Special Characters

\\*literal asterisks\\*

## Markdown extras

### GFM task list

- [x] GFM task list 1
- [x] GFM task list 2
- [ ] GFM task list 3
    - [ ] GFM task list 3-1
    - [ ] GFM task list 3-2
    - [ ] GFM task list 3-3
- [ ] GFM task list 4
    - [ ] GFM task list 4-1
    - [ ] GFM task list 4-2

`
